import React, { memo } from 'react';
import { PriorityChipRead } from '@atlassian/jira-issue-field-priority-chip/src/ui/read/index.tsx';
import type { CardPriority } from '../../../../../../model/types';

export const PriorityFieldStatic = ({ name, iconUrl }: CardPriority) => (
	<PriorityChipRead name={name} iconUrl={iconUrl} />
);

export default memo<CardPriority>(PriorityFieldStatic);
